import Vue from 'vue';

const apiUrl = `${process.env.VUE_APP_API_BASEURL}`;

export function sendBuddyResponse(message: string, token: string) {
   return Vue.axios.post(`${apiUrl}/v1/Buddy/Response`, { message }, { headers: { Authorization: `Bearer ${token}` } });
} 